import { Field } from "react-final-form";
import { Label } from "../../../shared/components/form/Layout";
import DateInput from "../../../shared/components/form/DateInput";
import Textarea from "../../../shared/components/form/Textarea";
import FieldContainer from "../../../shared/containers/form/FieldContainer";
import ErrorContainer from "../../../shared/containers/form/ErrorContainer";
import { useTranslation } from "react-i18next";
import Divider from "../../../shared/components/Divider";
import { CalendarIcon } from "@heroicons/react/20/solid";
import { ChatBubbleLeftEllipsisIcon } from "@heroicons/react/24/outline";
import InputNumber from "../../../shared/components/form/InputNumber";
import { faCar } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from 'moment';

const ItemFormFields = () => {
    const { t } = useTranslation();

    return (
        <>
            <div className={`my-16`}>
                <Divider className={"mb-8"}>Début et fin de stationnement</Divider>
                <div className="px-4 sm:flex sm:gap-16 sm:px-16">
                    <div className="sm:w-1/2">
                        <FieldContainer name="startDate">
                            <Label Icon={CalendarIcon} htmlFor="date">
                                Du
                            </Label>
                            <Field
                                id="startDate"
                                name="startDate"
                                placeholder="jj/mm/aaaa"
                                component={DateInput}
                                disabledAfter={moment().add(1, 'days').toDate()}
                            />
                            <ErrorContainer name="startDate" />
                        </FieldContainer>
                    </div>
                    <div className="mt-8 sm:mt-0 sm:w-1/2">
                        <FieldContainer name="endDate">
                            <Label Icon={CalendarIcon} htmlFor="to">
                                au :{" "}
                            </Label>
                            <Field
                                id="endDate"
                                name="endDate"
                                placeholder="jj/mm/aaaa"
                                component={DateInput}
                            />
                            <ErrorContainer name="endDate" />
                        </FieldContainer>
                    </div>
                </div>

                <Divider>Véhicule(s)</Divider>
                <div className="px-4 sm:flex sm:gap-16 sm:px-16">
                    <div className="sm:w-1/2">
                        <FieldContainer name="vehicleCount">
                            <Label
                                htmlFor="vehicleCount"
                                Icon={() => (
                                    <FontAwesomeIcon icon={faCar} className={"mr-2"} />
                                )}
                            >
                                Nombre de véhicules :
                            </Label>
                            <Field
                                id="vehicleCount"
                                name="vehicleCount"
                                placeholder="0"
                                component={InputNumber}
                            />
                            <ErrorContainer name="vehicleCount" />
                        </FieldContainer>
                    </div>
                    <div className="mt-8 sm:mt-0 sm:w-1/2">
                        <FieldContainer name="comment">
                            <Label htmlFor={"comment"} Icon={ChatBubbleLeftEllipsisIcon}>
                                Modèle de véhicule/commentaire
                            </Label>
                            <Field
                                id="comment"
                                name="comment"
                                component={Textarea}
                                rows="3"
                                placeholder="Clio 5 noire, BR-123-CD..."
                            />
                            <ErrorContainer name="comment" />
                        </FieldContainer>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ItemFormFields;
